export default __webpack_public_path__ + "static/1_TypesOfProductCard_WithoutMargins-5b6f0726f4bfff99c1906fc48d7369b6.png";